import { BrowserModule } from '@angular/platform-browser';
import { HttpModule, JsonpModule } from '@angular/http';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { environment } from '../environments/environment';
import { DeezerService } from './home/deezer.service';
import { EmailService } from './home/email.service';
import { AdresseipService } from './home/adresseip.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { RouterModule } from '@angular/router';
import { ROUTES } from './app.routes';
import { LoggedInGuard } from './loggedInGuard.service';
import { UserService } from './user.service';
import {NgsRevealModule} from 'ng-scrollreveal';
import {CountDown} from "../../node_modules/angular2-simple-countdown/countdown";
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { DeezerApiModule } from 'angular-deezer-api';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    CountDown
  ],
  imports: [
    BrowserModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule, // imports firebase/database, only needed for database features
    AngularFireAuthModule, // imports firebase/auth, only needed for auth features,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    JsonpModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyClfnpvDdZ6QPeeBrcYeXhEli4kODAKwDo'
    }),
    RouterModule.forRoot(ROUTES),
    NgsRevealModule.forRoot(),
    DeezerApiModule.forRoot()
  ],
  providers: [
    DeezerService,
    AdresseipService,
    LoggedInGuard,
    UserService,
    EmailService,
    {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/mac-jeremy/Projets/fairepart/src/app/app.module.ts